import { AxiosMethods, VetsuiteApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';
import {
  QueryFunctionContext,
  UseInfiniteQueryOptions
} from '@tanstack/react-query';
import { GetCustomers, GetDigitalShowroomCustomers } from './types';

export enum VetSuiteAPIKeys {
  DigitalShowroomCustomers = 'digital_showroom_customers',
  CatalogCustomers = 'catalog_customers',
  VatSuiteCustomer = 'vetsuite_customers'
}
const showroomLimit = 50;

export const getDigitalShowroomCustomersQuery = (
  searchStr: string
): UseInfiniteQueryOptions<GetDigitalShowroomCustomers> => ({
  queryKey: [VetSuiteAPIKeys.DigitalShowroomCustomers, searchStr],
  queryFn: (props: QueryFunctionContext) =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: VetsuiteApi.Overview,
      method: AxiosMethods.POST,
      body: {
        limit: showroomLimit,
        offset: props.pageParam ?? 0,
        searchStr
      }
    }),
  getNextPageParam: (lastPage, allPages) => {
    const totalItems = allPages.reduce(
      (acc: any, curr: any) => acc + (curr?.data?.length || 0),
      0
    );

    return lastPage?.data?.length < showroomLimit ? undefined : totalItems;
  }
});

const catalogCustomersLimit = 10;

export const getCatalogCustomers = (
  searchStr: string
): UseInfiniteQueryOptions<GetCustomers> => ({
  queryKey: [VetSuiteAPIKeys.CatalogCustomers, searchStr],
  queryFn: (props: QueryFunctionContext) =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: VetsuiteApi.CatalogCustomers,
      method: AxiosMethods.POST,
      body: {
        limit: catalogCustomersLimit,
        offset: props.pageParam ?? 0,
        searchStr
      }
    }),
  getNextPageParam: (lastPage, allPages) => {
    const totalItems = allPages.reduce(
      (acc: any, curr: any) => acc + (curr?.data?.length || 0),
      0
    );

    return lastPage?.data?.length < catalogCustomersLimit
      ? undefined
      : totalItems;
  }
});

const vetsuiteCustomersLimit = 50;

export const getVetSuiteCustomers = (
  searchStr: string
): UseInfiniteQueryOptions<GetCustomers> => ({
  queryKey: [VetSuiteAPIKeys.VatSuiteCustomer, searchStr],
  queryFn: (props: QueryFunctionContext) =>
    axiosHelper({
      baseURL: process.env.REVOPS_API,
      endpoint: VetsuiteApi.VetSuiteCustomers,
      method: AxiosMethods.POST,
      body: {
        limit: vetsuiteCustomersLimit,
        offset: props.pageParam ?? 0,
        searchStr
      }
    }),
  getNextPageParam: (lastPage, allPages) => {
    const totalItems = allPages.reduce(
      (acc: any, curr: any) => acc + (curr?.data?.length || 0),
      0
    );
    const currentPageNumber =
      Math.floor(totalItems / vetsuiteCustomersLimit) + 1;

    return lastPage?.data?.length < vetsuiteCustomersLimit
      ? undefined
      : currentPageNumber;
  }
});
